<template>
  <div id="slider"  class="wrapper">
    <div id="sliderContainer">
    <h2>Наши партнеры</h2>
    <div class="sliderWrapper">
    <carousel
      :per-page="slideDisplayCount"
      :navigate-to="0"
      :mouse-drag="false"
      :navigationEnabled="true"
      :navigationNextLabel="''"
      :navigationPrevLabel="''"
      >
  <slide>
   <img  class="icon" src="@/assets/img/sovcom.png"  />
  </slide>
  <slide>
    <img  class="icon" src="@/assets/img/alfa.png"  />
  </slide><slide>
     <img  class="icon" src="@/assets/img/tinkoff.png"  />
  </slide>

</carousel>
</div>
</div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'slider',
  data(){
return{
  devWidth:0,
}
  },
  components: {
    Carousel,
    Slide,
  },
  computed:{
    slideDisplayCount(){
    //todo devWidth следить за изменением экрана в динамике https://stackoverflow.com/questions/47219272/how-can-i-use-window-size-in-vue-how-do-i-detect-the-soft-keyboard
      return this.devWidth > 1140 ? 3 : 1;
    }
  },
  created(){
    console.log(window.outerWidth)
this.devWidth = window.outerWidth;
  },
  beforeCreate(){

  },
  mounted(){

  }
}
</script>

<style scoped>
#slider{ position: relative; background-color:white; height: 66vw; text-align: center;}
.sliderWrapper{position: relative; padding-top: 8vw;}
/deep/.VueCarousel-navigation{width: 75vw;position: absolute;}
/deep/.VueCarousel{position: absolute; justify-content: center; align-items: center; width: 100%;}
/deep/.VueCarousel-dot-container{display: none!important;}

/deep/.VueCarousel-navigation-next{background-size: cover;background-image: url('../assets/vector/nextarrow.svg'); background-repeat: no-repeat;}
/deep/.VueCarousel-navigation-prev{background-size: cover;padding: 8px;background-image: url('../assets/vector/backarrow.svg');  background-repeat: no-repeat;}
/deep/.VueCarousel-navigation-button{width: 7vw;height: 7vw;}
#sliderContainer{padding-top: 3vw;}
img, svg {width: 34vw;}

@media screen and (min-width: 760px) {
#sliderContainer{padding-top: 8vw; margin-left: auto;margin-right: auto; width:100%; padding-top: 35px;}
h2{font-size: 34px;}
    /deep/.VueCarousel-navigation-prev{background-size: cover;}
    /deep/.VueCarousel-navigation-next{background-size: cover;}

}
  @media screen and (min-width: 1140px) {
  /deep/.VueCarousel-navigation{display: none;}
  #slider{height: 400px;}
  .sliderWrapper{padding-top: 90px;}
   img{width: 200px;}

  }
</style>
